module.exports = __webpack_public_path__ + "img/PHOTO_ACTIVE.0a795a66.svg";